import React from 'react';

const HowItWorksCard = ({ icon: Icon, step, title, description, gradient }) => {
  return (
    <div className="text-center">
      <div className={`${gradient} w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4`}>
        <Icon className="w-8 h-8 text-pink-600" />
      </div>
      <h4 className="text-xl font-bold text-gray-900 mb-3">{step}. {title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

export default HowItWorksCard;
